import { render } from "./ReceiptingModal.vue?vue&type=template&id=5a249fcc"
import script from "./ReceiptingModal.vue?vue&type=script&lang=js"
export * from "./ReceiptingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__